import styles from './WhatsAppPreviewTemplate.module.css'

const TEMPLATE_CONFIG = {
  'Template 1': {
    intro: (name, title, companyName, employerName) =>
      `Hi ${name || 'Candidate First Name'} 👋\n${employerName || companyName || 'Employer Name'} at ${companyName || 'Company Name'} reviewed your profile and invited you to apply for ${title || 'Job Title'}.`,
    cta: () => (
      <>
        👉 <span className={styles.link}>Link</span>
      </>
    ),
  },
  'Template 2': {
    intro: (name, title, companyName) =>
      `Hi ${name || 'Candidate First Name'} 👋\n${companyName || 'Company Name'} invited you to apply for ${title || 'Job Title'}.`,
    cta: () => (
      <>
        👉 <span className={styles.link}>Link</span>
      </>
    ),
  },
  'Template 3': {
    intro: (name, title, companyName, employerName) =>
      `Hi ${name || 'Candidate First Name'} 👋\nYour background matched an open role and ${employerName || companyName || 'Employer Name'} wants you to apply.`,
    cta: () => (
      <>
        👉 <span className={styles.link}>Link</span>
      </>
    ),
  },
}

const SkillGigsAvatar = () => (
  <svg className={styles.waAvatar} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#FC1254" />
    <g clipPath="url(#waAvatarClip)">
      <path d="M9.43919 18.2585V18.3973C9.44406 18.6788 9.5033 18.9566 9.61348 19.2146C9.72366 19.4726 9.88262 19.7058 10.0812 19.9007C10.2798 20.0956 10.5141 20.2484 10.7706 20.3502C11.0271 20.4521 11.3007 20.501 11.5758 20.4942H15.2627C16.9132 20.4942 18.2485 21.8075 18.2485 23.4261V23.567C18.2485 25.1857 16.9132 26.4989 15.2627 26.4989H7.77623C7.5925 26.4989 7.4163 26.5736 7.28639 26.7066C7.15648 26.8395 7.0835 27.0199 7.0835 27.2079C7.0835 27.3959 7.15648 27.5762 7.28639 27.7092C7.4163 27.8421 7.5925 27.9168 7.77623 27.9168H15.2627C17.7102 27.9168 19.6945 25.9694 19.6945 23.567V23.4282C19.7029 21.0238 17.7186 19.0827 15.2627 19.0827H11.5758C11.4861 19.085 11.3968 19.069 11.3131 19.0357C11.2294 19.0024 11.1531 18.9524 11.0884 18.8886C11.0238 18.8248 10.9722 18.7486 10.9366 18.6642C10.901 18.5799 10.8821 18.4891 10.881 18.3973V18.2585C10.8875 18.0757 10.9641 17.9029 11.0941 17.7774C11.2241 17.652 11.3971 17.5839 11.5758 17.588H19.0602C19.2439 17.588 19.4201 17.5133 19.55 17.3804C19.6799 17.2474 19.7529 17.0671 19.7529 16.879C19.7529 16.691 19.6799 16.5107 19.55 16.3777C19.4201 16.2448 19.2439 16.1701 19.0602 16.1701H11.5758C11.3007 16.1633 11.0271 16.2122 10.7706 16.3141C10.5141 16.4159 10.2798 16.5687 10.0812 16.7636C9.88262 16.9585 9.72366 17.1917 9.61348 17.4497C9.5033 17.7077 9.44406 17.9855 9.43919 18.267" fill="white" />
      <path d="M11.5758 13.9116C9.1283 13.9116 7.14401 15.857 7.14401 18.2593V18.3981C7.14401 20.8004 9.1283 22.7479 11.5758 22.7479H15.2627C15.3518 22.7459 15.4403 22.7619 15.5234 22.7949C15.6064 22.828 15.6822 22.8775 15.7465 22.9405C15.8109 23.0036 15.8624 23.079 15.8983 23.1624C15.9341 23.2459 15.9535 23.3358 15.9554 23.4269V23.5679C15.9505 23.7514 15.875 23.9255 15.7452 24.0522C15.6155 24.179 15.4421 24.2482 15.2627 24.2448H7.77623C7.5925 24.2448 7.4163 24.3195 7.28639 24.4524C7.15648 24.5854 7.0835 24.7657 7.0835 24.9537C7.0835 25.1417 7.15648 25.3221 7.28639 25.455C7.4163 25.588 7.5925 25.6627 7.77623 25.6627H15.2627C15.5383 25.6706 15.8127 25.6226 16.07 25.5214C16.3274 25.4202 16.5625 25.2678 16.762 25.073C16.9614 24.8782 17.1212 24.6449 17.232 24.3865C17.3428 24.1282 17.4025 23.8499 17.4077 23.5679V23.4291C17.4031 23.1466 17.3438 22.8679 17.2332 22.609C17.1226 22.3502 16.963 22.1164 16.7634 21.9212C16.5639 21.7259 16.3286 21.5731 16.071 21.4717C15.8134 21.3702 15.5386 21.322 15.2627 21.33H11.5758C9.92536 21.33 8.5858 20.0167 8.5858 18.3981V18.2593C8.5858 16.6406 9.92118 15.3295 11.5716 15.3295H19.0602C19.2439 15.3295 19.4201 15.2548 19.55 15.1219C19.6799 14.9889 19.7529 14.8086 19.7529 14.6206C19.7529 14.4325 19.6799 14.2522 19.55 14.1193C19.4201 13.9863 19.2439 13.9116 19.0602 13.9116H11.5758Z" fill="white" />
      <path d="M31.9829 19.5946C31.5377 19.2439 30.9902 19.0567 30.4284 19.0629H26.7832C26.6018 19.0629 26.428 19.1376 26.2981 19.2706C26.1682 19.4035 26.0952 19.5839 26.0952 19.7719C26.0952 19.9599 26.1682 20.1403 26.2981 20.2732C26.428 20.4062 26.6018 20.4809 26.7832 20.4809H30.4493C30.6817 20.4792 30.9084 20.554 31.0961 20.6944C31.2491 20.8088 31.3688 20.9636 31.4423 21.1423C31.5158 21.321 31.5404 21.5168 31.5134 21.7087C31.3589 22.7365 30.9287 23.7003 30.2705 24.4926C29.6124 25.2848 28.7523 25.8746 27.7859 26.196C26.8196 26.5175 25.7851 26.5581 24.7975 26.3132C23.81 26.0684 22.9083 25.5477 22.1928 24.8093C21.1833 23.7733 20.6164 22.37 20.6164 20.9069C20.6164 19.4438 21.1833 18.0404 22.1928 17.0045C23.1418 16.0224 24.4109 15.4323 25.7579 15.3468C27.1049 15.2613 28.4355 15.6865 29.4957 16.5411C29.6292 16.6511 29.7975 16.7071 29.9687 16.6985C30.1399 16.6898 30.302 16.6171 30.4242 16.4941C30.5464 16.3711 30.6168 16.2047 30.6208 16.0296C30.6249 15.8545 30.5623 15.6849 30.4459 15.5561C29.166 14.5223 27.571 13.9832 25.9411 14.0336C24.1807 14.0893 22.509 14.8373 21.2736 16.122C20.33 17.1039 19.6916 18.3498 19.4389 19.7024C19.1862 21.055 19.3305 22.454 19.8536 23.7229C20.3767 24.9918 21.2551 26.0738 22.3782 26.8325C23.5013 27.5912 24.8187 27.9926 26.1644 27.9861C27.8191 27.9897 29.4198 27.3832 30.6734 26.2778C31.9075 25.1872 32.7176 23.6791 32.9561 22.0284C33.017 21.5976 32.9659 21.1581 32.8081 20.754C32.6502 20.3499 32.3911 19.9954 32.0568 19.7264" fill="white" />
      <path d="M28.8577 18.077C28.929 18.0056 28.9842 17.919 29.0192 17.8234C29.0543 17.7278 29.0684 17.6255 29.0607 17.5237C29.0529 17.4219 29.0234 17.3231 28.9743 17.2342C28.9252 17.1454 28.8576 17.0686 28.7764 17.0093C27.8723 16.3622 26.7736 16.0633 25.6749 16.1657C24.5762 16.2681 23.5484 16.7652 22.7734 17.5688C21.9127 18.4498 21.4292 19.6446 21.4292 20.8904C21.4292 22.1362 21.9127 23.331 22.7734 24.212C23.3827 24.8389 24.1498 25.2806 24.9897 25.488C25.8295 25.6954 26.7091 25.6604 27.5307 25.3869C28.3522 25.1134 29.0836 24.6122 29.6435 23.9388C30.2034 23.2655 30.5699 22.4464 30.7022 21.5727C30.7132 21.5028 30.6908 21.4317 30.6421 21.3806C30.5934 21.3295 30.5236 21.3038 30.4527 21.3107H26.7858C26.6044 21.3107 26.4306 21.3854 26.3007 21.5184C26.1708 21.6513 26.0978 21.8317 26.0978 22.0197C26.0978 22.2077 26.1708 22.388 26.3007 22.521C26.4306 22.6539 26.6044 22.7286 26.7858 22.7286H28.8369C28.5671 23.1449 28.2103 23.4944 27.7922 23.7519C27.3741 24.0094 26.9052 24.1685 26.4196 24.2175C25.934 24.2666 25.4438 24.2045 24.9845 24.0356C24.5253 23.8667 24.1086 23.5953 23.7645 23.2412C23.4591 22.9283 23.2184 22.5556 23.0567 22.1454C22.8951 21.7353 22.8157 21.296 22.8235 20.8538C22.8467 19.9984 23.1869 19.184 23.775 18.5758C24.3632 17.9675 25.1553 17.6109 25.9908 17.5781C26.7 17.5497 27.3986 17.7606 27.9793 18.1782C28.1125 18.2723 28.2737 18.3157 28.4349 18.3009C28.5962 18.2861 28.7472 18.214 28.8619 18.097L28.8577 18.077Z" fill="white" />
    </g>
    <defs>
      <clipPath id="waAvatarClip">
        <rect width="27.6923" height="27.6923" fill="white" transform="translate(6.15381 6.15381)" />
      </clipPath>
    </defs>
  </svg>
)

const WhatsAppPreviewTemplate = ({
  talentFirstName,
  jobTitle,
  jobDetails = [],
  message,
  selectedTemplate = 'Template 1',
  companyName,
  employerName,
}) => {
  const config = TEMPLATE_CONFIG[selectedTemplate] || TEMPLATE_CONFIG['Template 1']
  const intro = config.intro(talentFirstName || 'Candidate First Name', jobTitle || 'Job Title', companyName || 'Company Name', employerName)

  const jobDetailsString = jobDetails.length
    ? jobDetails.map((d) => `${d.label}: ${d.value}`)
    : null

  return (
    <div className={styles.container}>
      {/* Status Bar */}
      <div className={styles.statusBar}>
        <span className={styles.statusTime}>9:41</span>
        <div className={styles.statusIcons}>
          <svg viewBox="0 0 20 14" fill="#000" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="8" width="3" height="6" rx="0.8" />
            <rect x="4.5" y="5.5" width="3" height="8.5" rx="0.8" />
            <rect x="9" y="3" width="3" height="11" rx="0.8" />
            <rect x="13.5" y="0.5" width="3" height="13.5" rx="0.8" />
          </svg>
          <svg viewBox="0 0 20 14" fill="#000" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 11.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
            <path d="M5.5 7.5C7 6 8.4 5.2 10 5.2s3 .8 4.5 2.3L16 6.2C14.1 4.3 12.2 3.3 10 3.3S5.9 4.3 4 6.2l1.5 1.3z" />
            <path d="M1.5 3.8C4 1.4 6.8 0 10 0s6 1.4 8.5 3.8L20 2.3C17 .8 13.7 0 10 0S3 .8 0 2.3l1.5 1.5z" opacity=".4" />
          </svg>
          <svg viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="1.5" width="23" height="11" rx="2.5" stroke="#000" strokeWidth="1.2" />
            <rect x="2" y="3" width="19" height="8" rx="1.5" fill="#000" />
            <path d="M25 5v4a2 2 0 0 0 0-4z" fill="#000" />
          </svg>
        </div>
      </div>

      {/* WA Header */}
      <div className={styles.waHeader}>
        <span className={styles.waBack}>
          <svg width="10" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.82129 0.5C7.90691 0.500059 7.98026 0.526325 8.0625 0.608398C8.1448 0.694341 8.1709 0.771445 8.1709 0.857422C8.17081 0.944261 8.14426 1.01826 8.0625 1.10059L1.70117 7.46191H15.1113C15.2328 7.46193 15.3079 7.49726 15.3721 7.56055C15.4342 7.6219 15.4687 7.69362 15.4688 7.81348C15.4688 7.93333 15.4342 8.00505 15.3721 8.06641C15.3079 8.12969 15.2328 8.16502 15.1113 8.16504H1.70117L8.05664 14.5205C8.1389 14.602 8.16719 14.6788 8.16797 14.7705C8.16849 14.838 8.15383 14.8964 8.1123 14.9561L8.06055 15.0176C7.9806 15.0985 7.90742 15.1248 7.81836 15.124C7.72391 15.1231 7.6456 15.0931 7.5625 15.0107L0.614258 8.0625C0.561096 8.00833 0.5354 7.9662 0.523438 7.9375C0.50833 7.90019 0.5 7.8601 0.5 7.8125C0.50003 7.76491 0.508641 7.72576 0.523438 7.69043C0.535302 7.66099 0.560769 7.61862 0.614258 7.56445L7.56445 0.614258C7.65485 0.527034 7.73453 0.5 7.82129 0.5Z" fill="#606F7E" stroke="#606F7E" strokeWidth="0.3" />
          </svg>
        </span>
        <SkillGigsAvatar />
        <div className={styles.waContact}>
          <div className={styles.waContactName}>SkillGigs</div>
          <div className={styles.waContactSub}>tap here for contact info</div>
        </div>
        <div className={styles.waIcons}>
          <svg viewBox="0 0 24 24" fill="#007AFF" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4z" />
          </svg>
          <svg viewBox="0 0 24 24" fill="#007AFF" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
          </svg>
        </div>
      </div>

      {/* Chat Body */}
      <div className={styles.chatBody}>
        <div className={styles.dateChip}>12 December 2025</div>
        <div className={styles.bubble}>
          <p style={{ whiteSpace: 'pre-wrap' }}>{intro}</p>
          <p>
            <span className={styles.bold}>Message from the Hiring Team</span>
            <br />
            {message || 'Employer Custom Message'}
          </p>
          <p>
            <span className={styles.bold}>Job Details:</span>
            <br />
            {jobDetailsString
              ? jobDetailsString.map((line, idx) => (
                  <span key={idx}>
                    {line}
                    <br />
                  </span>
                ))
              : 'Job Details'}
          </p>
          <p>{config.cta()}</p>
          <p>
            📱Never Miss a Job Opportunity. Download Now on{' '}
            <span className={styles.link}>Android Link</span> | <span className={styles.link}>IOS Link</span>
          </p>
          <span className={styles.ts}>11:40 pm</span>
        </div>
      </div>

      {/* Input Bar */}
      <div className={styles.inputBar}>
        <span className={styles.inpPlus}>+</span>
        <div className={styles.inpField} />
        <div className={styles.inpIcons}>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#007AFF" strokeWidth="1.5" fill="none" />
            <circle cx="9" cy="10" r="1.3" fill="#007AFF" />
            <circle cx="15" cy="10" r="1.3" fill="#007AFF" />
            <path d="M8.5 15.5c.9 1.2 2.1 1.9 3.5 1.9s2.6-.7 3.5-1.9" stroke="#007AFF" strokeWidth="1.3" fill="none" strokeLinecap="round" />
          </svg>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#007AFF">
            <path d="M9 3L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.17L15 3H9zm3 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
          </svg>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#007AFF">
            <path d="M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm0 16a6 6 0 0 0 6-6h2a8 8 0 0 1-7 7.93V22h-2v-3.07A8 8 0 0 1 4 11h2a6 6 0 0 0 6 6z" />
          </svg>
        </div>
      </div>

      {/* Home Bar */}
      <div className={styles.homeBar}>
        <span />
      </div>
    </div>
  )
}

export default WhatsAppPreviewTemplate
